import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { WantedVehiclesForm } from '@modules/wantedVehicles/WantedVehiclesForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const wantedVehiclesUrl = '/metropolis/api/wv/vehicles';
export const wantedVehiclesLabel = 'Hledaná vozidla';
export const wantedVehiclesPath = '/wanted/vehicles';
export const wantedVehiclesGridName = 'module-vehicle';
export const WantedVehiclesGrid = compose<any, any>(
  withRouter,
  setDisplayName('WantedVehiclesGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: wantedVehiclesLabel }]),
  withColumns(Agenda.WANTED_VEHICLES),
  withProps(({ columns }) => ({
    name: 'module-vehicle',
    url: wantedVehiclesUrl,
    Form: WantedVehiclesForm,
    dialog: false,
    gridProps: {
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Cached />,
      columns,
      ActionBar: () => <ColumnManager agenda={Agenda.WANTED_VEHICLES} />,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: false,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 11
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/WantedVehiclesGrid.tsx